import { useTranslation } from 'react-i18next';
import { Flex } from '@chakra-ui/react';
import format from 'date-fns/format';

import type { ApiNabanDeed } from '@izimi/api';
import { useDateLocale } from '@izimi/hooks';

import { CustomIcon } from '../../../../icon';
import { NabanDetailsListCard } from '../../../components/NabanDetailsListCard';
import { NabanDetailsListItem } from '../../../components/NabanDetailsListItem';
import { getEcbEnterpriseUrl } from '../../../utils';
import { nabanDetailsListCardContentProps } from './styles';

type Props = {
  document: ApiNabanDeed['bceEnterpriseNumberFeedback'];
};

export const NabanDeedECBDocuments = ({ document }: Props) => {
  const {
    t,
    i18n: { language },
  } = useTranslation('naban');
  const locale = useDateLocale(language);

  return (
    <NabanDetailsListCard title={t('deed.ecbDocuments.title')}>
      <Flex
        flexDirection='row'
        alignItems='center'
        w='full'
        {...nabanDetailsListCardContentProps}
        gap={4}>
        {document?.receivalDate && (
          <NabanDetailsListItem
            flex={{
              base: 1,
              md: '0 0 45%',
            }}
            title={t('deed.ecbDocuments.label.receivedAt')}
            value={format(new Date(document.receivalDate), 'PPP', { locale })}
          />
        )}
        {document?.enterpriseNumber && (
          <NabanDetailsListItem
            flex={1}
            title={t('deed.ecbDocuments.label.enterpriseNumber')}
            value={
              <>
                {document.enterpriseNumber}
                <span>
                  {' ('}
                  <a
                    target='_blank'
                    rel='noopener noreferer noreferrer'
                    href={getEcbEnterpriseUrl({
                      bceEnterpriseNumber: document.enterpriseNumber,
                      lang: language,
                    })}>
                    {t('deed.ecbDocuments.cbeLink.label')}
                    <CustomIcon
                      name='external-link-small'
                      color='neutral500'
                      display='inline-block'
                      ml={0.25}
                      mr={0.25}
                      verticalAlign='text-top'
                      transform='translateY(1px)'
                    />
                  </a>
                  )
                </span>
              </>
            }
          />
        )}
      </Flex>
    </NabanDetailsListCard>
  );
};
